/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TierType = "CORE" | "ENTERPRISE" | "FREE_FOREVER" | "LITE" | "PRO" | "TRIAL" | "%future added value";
export type trialEnd_viewer = {
    readonly id: string;
    readonly actualPersonId: string | null;
    readonly company: {
        readonly id: string;
        readonly tier: TierType | null;
    } | null;
    readonly " $refType": "trialEnd_viewer";
};
export type trialEnd_viewer$data = trialEnd_viewer;
export type trialEnd_viewer$key = {
    readonly " $data"?: trialEnd_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"trialEnd_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "trialEnd_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tier",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
(node as any).hash = '36432dbf6ac00b8cb27881451eec0703';
export default node;
